<template>
  <ul :class="[theme.list, listClass]" v-if="items?.length">
    <li
      v-for="(item, idx) in items"
      :key="idx"
      :class="[theme.item, itemClass]"
    >
      <!-- Check ou icône -->
      <span
        v-if="checks.length && checks[idx]"
        :class="[theme.check, checkClass]"
      >
        <component
          v-if="checks[idx].component"
          :is="checks[idx].component"
          v-bind="checks[idx].props || {}"
        />
        <span v-else v-html="checks[idx]"></span>
      </span>

      <!-- Label -->
      <span class="ml-2" v-html="item"></span>
    </li>
  </ul>
</template>

<script setup>
import { checkListBlockTheme } from './scripts/themeHelpers'

const props = defineProps({
  items: { type: Array, default: () => [] },
  checks: { type: Array, default: () => [] },
  variant: { type: String, default: 'default' },
  listClass: { type: String, default: '' },
  itemClass: { type: String, default: '' },
  checkClass: { type: String, default: '' },
})

const theme = checkListBlockTheme(props.variant)
</script>

<style scoped>
/* Styles génériques si nécessaire */
</style>
